import type { AuthData } from '../../types/auth/authData'
import type { OktaAuthData as OktaAuthData } from '../../types/auth/oktaAuthData'
import { OauthOption } from '../../types/auth/oauthOption'

export interface NormalizedAuthData {
  name: string
  surname: string
  displayName: string
  email: string
  profilePicture: string
  idToken: string
  expiresIn: string
  refreshToken?: string
}

function splitName(fullName?: string | null): [string, string] {
  if (!fullName) return ['', '']

  const parts = fullName.trim().split(/\s+/)
  if (parts.length === 1) return [parts[0], '']

  const [first, ...rest] = parts
  return [first, rest.join(' ')]
}

function normalizeGenericAuth(data: AuthData): NormalizedAuthData {
  const displayName = data.displayName ?? ''
  const [name, surname] = splitName(displayName)

  return {
    name,
    surname,
    displayName,
    email: data.email,
    profilePicture: data.profilePicture ?? '',
    idToken: data.idToken,
    expiresIn: data.expiresIn,
    refreshToken: data.refreshToken ?? '',
  }
}

function normalizeOktaAuth(data: OktaAuthData): NormalizedAuthData {
  const displayName = data.name ?? ''
  const [name, surname] = splitName(displayName)

  return {
    name,
    surname,
    displayName,
    email: data.email,
    profilePicture: '',
    idToken: data.access_token,
    expiresIn: '',
  }
}

export function normalizeAuthData(
  authData: AuthData | OktaAuthData,
  provider: OauthOption
): NormalizedAuthData {
  switch (provider) {
    case OauthOption.Okta:
      return normalizeOktaAuth(authData as OktaAuthData)

    case OauthOption.Google:
    case OauthOption.Microsoft:
    default:
      return normalizeGenericAuth(authData as AuthData)
  }
}
